/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { CustomFontIndexPathParams, CustomFontIndexResponse } from '../types/CustomFontIndex'

/**
 * GET /organisations/:organisation/fonts
 * @see backend/nexus/modules/Organisation/Http/Controllers/CustomFontController.php CustomFontController::index
 */
export async function customFontIndex(
	organisation: CustomFontIndexPathParams['organisation'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CustomFontIndexResponse>> {
	return axiosInstance.get(`/organisations/${organisation}/fonts`, config)
}
